import { render } from "./secondNavbar.vue?vue&type=template&id=4fbcf914&scoped=true"
import script from "./secondNavbar.vue?vue&type=script&lang=js"
export * from "./secondNavbar.vue?vue&type=script&lang=js"

import "./secondNavbar.vue?vue&type=style&index=0&id=4fbcf914&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbcf914"]])

export default __exports__